export const getHasUserSettings = state => state.userSettings.get('hasUserSettings');
export const getSettingsId = state => state.userSettings.getIn(['settings', 'id']);



/** WEBPACK FOOTER **
 ** ./src/selectors/user-settings-selectors.js
 **/